import gql from 'graphql-tag'

const listRecipes = gql`
query listRecipes($params: ListQueryArgs) {
	cashAssist {
		listRecipes(params: $params) {
			hasNextPage
			items {
				id
				name
			}
		}
	}
}
`

export default listRecipes
